<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    isExport: false,
    isExport1: false,
  }),

  methods: {
    ...mapActions("admin-applications", ["EXPORT_EXAM"]),
    ...mapActions("admin-applications", ["EXPORT_RESULT"]),

    onExport() {
      this.isExport = true;
      this.EXPORT_EXAM().then(() => {
        this.isExport = false;
      });
    },

    onResultList() {
      this.isExport1 = true;
      this.EXPORT_RESULT().then(() => {
        this.isExport1 = false;
      });
    },
  },
};
</script>

<template>
  <div>
    <div class="export">
      <h3 class="title">{{ $t("Export to excel exam") }}</h3>
      <v-btn
        :loading="isExport"
        color="accent"
        class="font-made ml-2 transform-none"
        :disabled="excelExportDisabled"
        @click="onExport"
      >
        {{ $t("Export to excel") }}
      </v-btn>
    </div>
    <div class="export">
      <h3 class="title">{{ $t("Export to excel result") }}</h3>
      <v-btn
        :loading="isExport1"
        color="accent"
        class="font-made ml-2 transform-none"
        :disabled="excelExportDisabled"
        @click="onResultList"
      >
        {{ $t("Export to excel") }}
      </v-btn>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.search-wrapper {
  display: flex;

  @media only screen and(max-width:1299px) {
    padding: 10px 20px;
  }

  @media only screen and(min-width:1400px) {
    width: 400px !important;
  }

  @media only screen and(min-width:1300px) {
    width: 350px;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.export {
  margin-top: 30px;
  margin-left: 30px;
}
.title {
  margin-left: 10px;
  margin-bottom: 5px;
}
</style>
